import Vue from "vue";
import VueRouter from "vue-router";
import auth from "@/@core/auth";
import authRoutes from "./routes/auth";
import pagesRoutes from "./routes/pages";
Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: {
        pageTitle: "Menutech",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
    ...authRoutes,
    ...pagesRoutes,
  ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach((to, from) => {
  // ← اضافه‌شده: تنظیم title بر اساس meta.pageTitle
  const nearest = to.matched
    .slice().reverse()
    .find(r => r.meta && r.meta.pageTitle);
  document.title = nearest
    ? nearest.meta.pageTitle
    : "Menutech";
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
auth.handleRouter(router);
export default router;
